export default __webpack_public_path__ + "static/media/isChecked.022cd007.svg";